import apiClient from './ApiService'

export default {
  getEmpresas(page = 1, limit = 15, filters = {}) {
    return apiClient.get('/empresas', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getEmpresa(id) {
    return apiClient.get(`/empresas/${id}`)
  },
  
  createEmpresa(empresa) {
    return apiClient.post('/empresas', empresa)
  },
  
  updateEmpresa(id, empresa) {
    return apiClient.put(`/empresas/${id}`, empresa)
  },
  
  deleteEmpresa(id) {
    return apiClient.delete(`/empresas/${id}`)
  },
  
  exportarListado(formato, filtros = {}) {
    return apiClient.get('/empresas/exportar', {
      params: {
        formato,
        ...filtros
      },
      responseType: 'blob'
    })
  }
}